// extracted by mini-css-extract-plugin
module.exports = {"main":"home-page_main__iB_Jl","title":"home-page_title__BlCVb","services":"home-page_services__yBWMS"};